import ServiceOrderSummary from './service-order-summary';


export default class Service {

  constructor(service) {
    this.reset(service);
  }

  reset(service) {
    this.service = service;
    this.order_summary = new ServiceOrderSummary(service);  // helper to set order summary jazz
    this.service_class_model = this.service.service_class_model;
    this.provider = this.service_class_model.provider;
  }

}



// WEBPACK FOOTER //
// ./src/lib/ssu/input_models/service.js